export default __webpack_public_path__ + "Kastelov - Axiforma Book.otf";